import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell } from 'recharts'

import type { RoleDistribution } from '@/hooks'

// 角色颜色映射
const ROLE_COLORS: Record<string, string> = {
  director: '#3B82F6', // blue
  finance: '#10B981', // green
  hr: '#F59E0B', // amber
  admin: '#EF4444', // red
  pm: '#8B5CF6', // purple
  developer: '#06B6D4', // cyan
}

interface RoleBarChartProps {
  data: RoleDistribution[]
}

export function RoleBarChart({ data }: RoleBarChartProps) {
  if (data.length === 0) {
    return (
      <div className="text-muted-foreground flex h-[300px] items-center justify-center">
        暂无数据
      </div>
    )
  }

  const chartData = data.map((item) => ({
    ...item,
    name: item.roleName,
    value: item.employeeCount,
    color: ROLE_COLORS[item.role] ?? '#6B7280',
  }))

  return (
    <div className="h-[300px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={chartData}
          layout="vertical"
          margin={{ top: 5, right: 30, left: 60, bottom: 5 }}
        >
          <XAxis type="number" allowDecimals={false} />
          <YAxis type="category" dataKey="name" width={80} tick={{ fontSize: 12 }} />
          <Tooltip
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            content={({ active, payload }: { active?: boolean; payload?: any }) => {
              if (active && payload && payload.length) {
                const data = payload[0].payload as (typeof chartData)[0]
                return (
                  <div className="bg-background rounded-lg border p-3 shadow-lg">
                    <p className="font-medium">{data.roleName}</p>
                    <p className="text-muted-foreground text-sm">员工数: {data.employeeCount} 人</p>
                  </div>
                )
              }
              return null
            }}
          />
          <Bar dataKey="value" radius={[0, 4, 4, 0]}>
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
